<template>
  <table class="table table-striped table-bordered">
    <thead>
      <tr>
        <th></th>
        <th>ID</th>
        <th>Vencimento</th>
        <th>Valor atual</th>
        <th>ID externo</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="(bill, index) in value" :key="index">
        <td>
          <input type="checkbox" v-model="bill.selected" @change="$emit('input', value)">
        </td>
        <td>{{ bill.id }}</td>
        <td>{{ bill.due_date | formatDate }}</td>
        <td>{{ bill.value | formatCurrency }}</td>
        <td>{{ bill.external_id || '-' }}</td>
      </tr>
    </tbody>
  </table>
</template>

<script>
export default {
  props: {
    value: {
      type: Array,
      default: () => [],
    },
  },
};
</script>
